export const FETCH_DISCIPLINES = "FETCH_DISCIPLINES";



